{
  "name": "gea-shop",
  "version": "1.1.15",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build:develop": "ng build -c develop",
    "build:test": "ng build -c test",
    "build:main": "ng build -c main",
    "build:develop:ssr": "ng build -c develop",
    "build:test:ssr": "ng build -c test",
    "build:main:ssr": "ng build -c main",
    "watch": "ng build --watch --configuration development",
    "dev": "ng run gea-shop:serve --host 0.0.0.0 --port 4000",
    "serve:ssr": "node dist/gea-shop/server/server.mjs",
    "build:ssr": "ng build",
    "prerender": "ng run gea-shop:prerender",
    "e2e": "ng e2e",
    "test": "jest",
    "test:watch": "jest --watch"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.17",
    "@angular/common": "^21.2.17",
    "@angular/compiler": "^21.2.17",
    "@angular/core": "^21.2.17",
    "@angular/forms": "^21.2.17",
    "@angular/localize": "^21.2.17",
    "@angular/platform-browser": "^21.2.17",
    "@angular/platform-browser-dynamic": "^21.2.17",
    "@angular/platform-server": "^21.2.17",
    "@angular/router": "^21.2.17",
    "@angular/ssr": "^21.2.8",
    "@friendlycaptcha/sdk": "^0.2.0",
    "@gea-waldviertler-website/gea-models": "1.1.43",
    "@gea-waldviertler-website/shop-lib": "1.21.14",
    "@ng-bootstrap/ng-bootstrap": "20.0.0",
    "@popperjs/core": "^2.11.6",
    "@rkuzsma/karma-docker-launcher": "^1.0.4",
    "@sentry/angular": "^10.24.0",
    "@sentry/browser": "^10.25.0",
    "@sentry/node": "^10.47.0",
    "@stripe/stripe-js": "^8.5.3",
    "@types/leaflet": "^1.9.3",
    "angularx-qrcode": "^21.0.5",
    "array.prototype.at": "^1.1.3",
    "bootstrap": "^5.3.8",
    "express": "^4.18.2",
    "install": "^0.13.0",
    "js-md5": "^0.8.3",
    "leaflet": "^1.9.3",
    "marked": "^15.0.8",
    "ngx-matomo-client": "^9.0.0",
    "ngx-paypal": "^11.0.0",
    "ngx-stripe": "^21.8.0",
    "rxjs": "^7.8.1",
    "sepa-payment-qr-code": "^2.0.2",
    "string.prototype.at": "^1.0.6",
    "tslib": "^2.8.1",
    "typescript": "^5.9.0",
    "uuid": "^11.1.1"
  },
  "optionalDependencies": {
    "@rollup/rollup-linux-x64-musl": "*"
  },
  "overrides": {
    "qs": "^6.14.1",
    "tar": "^7.5.7",
    "vite": "^7.3.5",
    "esbuild": "^0.28.1",
    "webpack-dev-server": "^5.2.5",
    "js-yaml": "^4.2.0",
    "@babel/core": "^7.29.7",
    "sockjs": {
      "uuid": "^11.1.1"
    }
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.8",
    "@angular-devkit/core": "^21.2.8",
    "@angular/cli": "^21.2.8",
    "@angular/compiler-cli": "^21.2.17",
    "@angular/platform-browser-dynamic": "^21.2.17",
    "@emnapi/core": "1.10.0",
    "@emnapi/runtime": "1.10.0",
    "@sentry/cli": "^2.58.2",
    "@types/express": "^4.17.17",
    "@types/jest": "^30.0.0",
    "@types/marked": "^4.3.1",
    "@types/node": "^22.12.17",
    "@types/qrcode": "^1.5.2",
    "@types/uuid": "^9.0.7",
    "baseline-browser-mapping": "^2.9.19",
    "browser-sync": "^3.0.0",
    "jest": "^30.2.0",
    "jest-environment-jsdom": "^30.2.0",
    "jest-junit": "^17.0.0",
    "jest-preset-angular": "^17.0.0",
    "ts-node": "^10.9.2",
    "webpack-bundle-analyzer": "^5.0.1"
  }
}
